import React, { useState } from "react";
import AboutImg1 from "../Img/1.png";
import AboutImg2 from "../Img/2.png";
import AboutImg3 from "../Img/3.png";
import { BadgeCheck, Users, Clock4, Heart } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const navigate = useNavigate();

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const accordionItems = [
    {
      title: "Mission",
      content:
        "To craft stylish, high-quality apparel that combines comfort, elegance, and modern fashion trends, making every outfit a statement.",
    },
    {
      title: "Vision",
      content:
        "To become a leading clothing brand recognized globally for innovation, premium quality, and customer-centric designs.",
    },
    {
      title: "Core Values",
      content:
        "Quality, creativity, sustainability, and customer satisfaction — ensuring every customer feels confident and stylish.",
    },
  ];

  return (
    <div className="rsi-about-container">
      {/* Section 1: Hero */}
      <section className="rsi-hero-section">
        <div className="rsi-hero-content">
          <h1 className="rsi-hero-title">Welcome to Armani Makhana Company</h1>
          <p className="rsi-hero-subtitle">
            Your destination for premium fashion, trendy apparel, and timeless
            designs that make every occasion stylish.
          </p>
          <button
            className="rsi-hero-button"
            onClick={() => navigate("/products")}
          >
            Shop Now
          </button>
        </div>
      </section>

      {/* Section 2: Our Story */}
      <section className="rsi-story-section">
        <div className="rsi-story-wrapper">
          <div className="rsi-story-text">
            <h2 className="rsi-section-title">Our Story</h2>
            <p>
              Armani Makhana Company was founded with a passion for fashion and
              quality. What started as a small boutique collection has grown
              into a brand trusted by fashion enthusiasts nationwide.
            </p>
            <p>
              We believe clothing is not just about style — it's about
              confidence, self-expression, and comfort. Every piece we design
              is carefully crafted with premium fabrics and attention to detail.
            </p>
            <p>
              From casual wear to special occasion collections, Armani Makhana
              Company is here to elevate your wardrobe with elegance and modern
              flair.
            </p>

            <div className="rsi-accordion">
              {accordionItems.map((item, index) => (
                <div
                  className={`rsi-accordion-item ${
                    openAccordion === index ? "open" : ""
                  }`}
                  key={index}
                >
                  <div
                    className="rsi-accordion-header"
                    onClick={() => toggleAccordion(index)}
                  >
                    {item.title}
                    <span className="rsi-accordion-icon">
                      {openAccordion === index ? "−" : "+"}
                    </span>
                  </div>

                  <AnimatePresence initial={false}>
                    {openAccordion === index && (
                      <motion.div
                        className="rsi-accordion-wrapper"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{
                          duration: 0.35,
                          ease: [0.4, 0, 0.2, 1],
                        }}
                      >
                        <div className="rsi-accordion-content">
                          {item.content}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              ))}
            </div>
          </div>

          <div className="rsi-story-images">
            <img
              src="https://plus.unsplash.com/premium_photo-1661326297568-65045688d10a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8bWVucyUyMGNsb3RoaW5nfGVufDB8fDB8fHww"
              alt="Armani Makhana Story"
              className="rsi-story-img"
            />
          </div>
        </div>
      </section>

      {/* Section 3: Why Choose Us */}
      <section className="rsi-features-section">
        <h2 className="rsi-section-title">Why Choose Armani Makhana?</h2>
        <ul className="rsi-features-list">
          <li>
            <BadgeCheck className="rsi-icon" /> Premium-quality fabrics & modern designs
          </li>
          <li>
            <Users className="rsi-icon" /> Trusted by fashion enthusiasts across India
          </li>
          <li>
            <Clock4 className="rsi-icon" /> Quick delivery & hassle-free returns
          </li>
          <li>
            <Heart className="rsi-icon" /> Designed with passion & attention to detail
          </li>
          <li>
            <BadgeCheck className="rsi-icon" /> Wide range of casual and formal collections
          </li>
          <li>
            <Users className="rsi-icon" /> Growing community of style-conscious customers
          </li>
        </ul>
      </section>

      {/* Section 5: Testimonials */}
      <section className="rsi-testimonials-section">
        <h2 className="rsi-section-title">What Our Customers Say</h2>
        <div className="rsi-testimonial-grid">
          <div className="rsi-testimonial-card">
            <p>
              "Amazing quality and stylish designs! Armani Makhana has become my go-to brand for all occasions."
            </p>
            <span className="rsi-testimonial-name">– Riya Mehta, Customer</span>
          </div>
          <div className="rsi-testimonial-card">
            <p>
              "The fabric feels premium and the fit is perfect. Highly recommended for anyone who loves fashion."
            </p>
            <span className="rsi-testimonial-name">– Arjun Singh, Customer</span>
          </div>
          <div className="rsi-testimonial-card">
            <p>
              "Beautiful collection, fast delivery, and excellent customer service. I love shopping here!"
            </p>
            <span className="rsi-testimonial-name">– Sneha Kapoor, Customer</span>
          </div>
        </div>
      </section>

      {/* Section 6: Call to Action */}
      <section className="rsi-cta-section">
        <h2 className="rsi-cta-title">Upgrade Your Wardrobe Today</h2>
        <p className="rsi-cta-subtitle">
          Explore our premium collections and experience fashion, comfort, and elegance in every outfit.
        </p>
        <button
          className="rsi-cta-button"
          onClick={() => navigate("/products")}
        >
          Shop Now
        </button>
      </section>
    </div>
  );
};

export default AboutUs;
